<template>
  <div class="animated fadeIn">
    <div v-if="saving">
      <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Salvo...
    </div>
    <b-modal
      title="ATTENZIONE"
      class="modal-success"
      v-model="okStage"
    >
      <!-- <template slot="modal-cancel">NO</template>
      <template slot="modal-ok">SI</template> -->
      <!-- ="{ ok, ok, cancel }" -->
      <template #modal-footer>
        <b>Custom Footer</b>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="sipres(false)">
            SI (SOLO ORA)
        </b-button>
        <b-button size="sm" variant="info" @click="sipres(true)">
            SI (GIORNATA)
        </b-button>
        <!-- Button with custom close trigger value -->
        <b-button size="sm" variant="danger" @click="okStage=false">
            NO
        </b-button>
      </template>
      <template v-if="present">
        Vuoi ELIMINARE questa presenza ?
      </template>
      <template v-else>
        Vuoi INSERIRE questa presenza ?
      </template>
    </b-modal>
    <b-modal
      title="ATTENZIONE"
      class="modal-success"
      v-model="okDel"
      @ok="okDel=false,elimina()"
      ok-variant="success"
      :ok-only="false"
    >
      <template slot="modal-cancel">NO</template>
      <template slot="modal-ok">SI</template>
      Vuoi davvero eliminare questa ora ?
    </b-modal>
    <b-modal
      title="ATTENZIONE"
      class="modal-success"
      v-model="okIns"
      @ok="okIns=false,aggiungi()"
      ok-variant="success"
      :ok-only="false"
    >
      <template slot="modal-cancel">NO</template>
      <template slot="modal-ok">SI</template>
      Vuoi aggiungere questa ora di sostegno: {{dateIns}}  ?
    </b-modal>
    <b-modal
      title="ATTENZIONE"
      class="modal-warning"
      v-model="noOre"
      @ok="noOre=false"
      ok-variant="success"
      :ok-only="true"
    >
      <template slot="modal-ok">OK</template>
      Sostegno non inseribile: manca l'incarico o l'ora
    </b-modal>
    <b-modal
      title="SCEGLI"
      class="modal-warning"
      v-model="chooseOk"
      @ok="chooseOk=false"
      ok-variant="danger"
      :ok-only="true"
    >
      <template slot="modal-ok">Annulla</template>
      Scegli l'opzione corretta
      <div v-for="opt in insOptions" :key="opt.calid">
        <a href="#" @click="scegli(opt)" >
          <i class="fa fa-hand-o-right"></i>{{opt.mnome}} - {{opt.numero}} - {{opt.nome}}
        </a>
      </div>
    </b-modal>
    <div>
      <h1>
        {{nome}}
        <a href="#" @click="stampami" id="stampa" title="stampa">
          <i class="fa fa-print"></i>
        </a>
        <span style="float:right;">&nbsp;EDIT:
          <toggle-button
            v-if="sostegno"
            :value="false"
            color="#82C7EB"
            :labels="true"
            @change="tbChange"
          />
        </span>
      </h1>
    </div>
    <full-calendar
      id="calendar"
      :options="calendarOptions"
      @event-render="eventRender"
      ref="fc"
    ></full-calendar>
  </div>
</template>

<script>
// import "fullcalendar/dist/locale/it";
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import adaptivePlugin from '@fullcalendar/adaptive'
import itLocale from '@fullcalendar/core/locales/it';
import 'bootstrap/dist/css/bootstrap.css';
import { SemipolarSpinner } from "epic-spinners";
import { ToggleButton } from "vue-js-toggle-button";
import { DateTime } from "luxon";
window.jQuery = require("jquery");
require("print-this");

export default {
  name: "CalPers",
  mixins: [window.myMixin],
  components: {
    SemipolarSpinner,
    ToggleButton,
    FullCalendar,
  },
  data: function () {
    var io = this;
    return {
        calendarOptions: {
            editable: true,
            plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin,listPlugin, adaptivePlugin ],
            initialView: 'dayGridMonth',
            eventClick: this.eventClick,
            headerToolbar: {
                left: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                center: 'title',
                right: 'today prev,next'
            },
            themeSystem: 'bootstrap',
            locale: itLocale,
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            hiddenDays: window.ENAC ? [] : [ 0 ],
            slotMinTime: '08:00:00',
            slotMaxTime: '18:00:00',
            allDaySlot: false,
            eventTimeFormat: {
                omitZeroMinute: false,
                hour: '2-digit',
                minute: '2-digit',
            },
            eventSources: [
            {
            events(info, callback) {
                console.log("start:", info);
                io.$http
                .get(window.baseurl + "/tshowcalpers", {
                    params: {
                    json: 1,
                    start: info.startStr.split("T")[0],
                    end: info.endStr.split("T")[0],
                    },
                })
                .then((response) => {
                    // console.log("RESP:", response.data);
                    // response.data.map(d => ({...d, allDay: false }))
                    callback(response.data);
                });
            },
            color: "black",
            textColor: "white",
            },
        ],
      },
      okStage: false,
      backOK: false, // modifiche retroattive per debug)
      saving: false,
      insOptions: [],
      chooseOk: false,
      noOre: false,
      okDel: false,
      okIns: false,
      cal2del: false,
      dateIns:"",
      calid: 0,
      present: false,
      sostegno: false,
      canEdit: false,
      viewType: "",
    };
  },
  async mounted(){
    let response = await this.$http.get(window.baseurl + "/haSostegno", {
      params: {
        json: 1,
        docid: this.getUserID(),
      },
    });
    this.sostegno = response.data
    //console.log("SOSTEGNO",this.sostegno,this.sostegno===true)
  },
  computed: {
    nome() {
      return this.getUserName();
    },
  },
  methods: {
    tbChange(ev){
      this.canEdit = ev.value
    },
    viewRender(view,element){
      console.log("viewRender",view.type,element)
      this.viewType = view.type
    },
    async scegli(opt){
      this.saving = true
      let response = await this.$http.get(window.baseurl + "/addcalsost", {
        params: {
          json: 1,
          calid: opt.calid,
          dateIns: this.dateIns,
          docid: this.getUserID(),
        },
      });
      this.chooseOk = false
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
      this.saving = false
    },
    async aggiungi(){
      let response = await this.$http.get(window.baseurl + "/addcalsost", {
        params: {
          json: 1,
          calid: false,
          dateIns: this.dateIns,
          docid: this.getUserID(),
        },
      });
      console.log("RESP:", response.data);
      if(response.data=="OK") {
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
      } else if(response.data=="NOORE"){
        this.noOre=true
      } else {
        this.insOptions = response.data
        this.chooseOk = true
      }
    },
    async elimina() {
      this.saving = true
      let response = await this.$http.get(window.baseurl + "/delcalsost", {
        params: {
          json: 1,
          calid: this.cal2del,
          docid: this.getUserID(),
        },
      });
      // console.log("RESP:", response.data);
      this.saving = false
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
    },
    async sipres(giorno) {
      this.saving = true
      console.log("pres",giorno,this.calid,this.present)
      let response = await this.$http.get(window.baseurl + "/setPresAlunnoStage", {
        params: {
          giorno: giorno,
          calid: this.calid,
          present: this.present,
          corsid: this.getUserID(),
        },
      });
      console.log("RESP:", response.data);
      this.saving = false
      this.okStage = false
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
    },
    eventClick: function (event) {
      console.log("eventClick", event);
      let evdate = event.event.startStr.split("T")[0]
      let nowDate = DateTime.local().toISODate()
    //   console.log("ectest",this.canEdit,evdate,nowDate,event.event.backgroundColor)
      if (event.event._def.extendedProps.tp==3 && event.calid > 0 && this.sostegno && this.canEdit && (evdate>=nowDate || this.backOK)) {
        this.okDel = true;
        this.cal2del = event.event._def.extendedProps.calid;
      } else if (event.event.backgroundColor=="DarkRed" && (this.getAlunnoID()>0 && evdate==nowDate) ) { //   || window.DEBUG
        console.log("DIALOG ?")
        this.calid = event.event._def.extendedProps.calid
        this.present = event.event.title.endsWith("(P)")
        this.okStage = true;
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
      }
    },
    dateClick: function (event) {
      let evdate = event.format("YYYY-MM-DD")
      let nowDate = DateTime.local().toISODate()
      console.log("dateClick", event,evdate,nowDate);
      // console.log("dateClick", event.format("YYYY-MM-DD hh:mm"),evdate,nowDate);
      if (this.sostegno && this.viewType!='month' && this.canEdit && (evdate>=nowDate || this.backOK)) {
        this.dateIns = event.format("YYYY-MM-DD hh") + ":00";
        this.okIns = true;
        let calendar = this.$refs.fc.getApi()
        calendar.refetchEvents()
        // this.$refs.fc.fireMethod("refetchEvents");
      }
    },
    eventRender: function (event) {
      // console.log("EVENTRENDER", this.getUserName()); // funzione globale !
    },
    stampami: function () {
      //jQuery('#calendar').printThis();
      const prtHtml = document.getElementById("calendar").parentNode.innerHTML;
      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
    //   console.log(`${stylesHtml}`)
      var html = `<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          <style type="text/css">
            #calendar div div a {
                color: black !important;
                text-decoration: none !important;
            }
            #calendar div.fc-event-main[style] {
                color: black !important;
            }
          </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`;
      console.log("HTML",html)
      WinPrint.document.write(html);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();

      // let blob = new Blob([html],{type: 'text/html'})
      // let link = document.createElement('a')
      // link.href = window.URL.createObjectURL(blob)
      // link.download = 'cal.html'
      // link.click()
    },
  },
};
</script>

<style>
/*!
 * FullCalendar v3.9.0
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
/*!
 * FullCalendar v3.9.0 Print Stylesheet
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
/*
 * Include this stylesheet on your page to get a more printer-friendly calendar.
 * When including this stylesheet, use the media='print' attribute of the <link> tag.
 * Make sure to include this stylesheet IN ADDITION to the regular fullcalendar.css.
 */
@media print {
  .fc {
    max-width: 100% !important;
  }

  /* Global Event Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc-event {
    background: #fff !important;
    color: #000 !important;
    page-break-inside: avoid;
  }

  .fc-event .fc-resizer {
    display: none;
  }

  /* Table & Day-Row Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc th,
  .fc td,
  .fc hr,
  .fc thead,
  .fc tbody,
  .fc-row {
    border-color: #ccc !important;
    background: #fff !important;
  }

  /* kill the overlaid, absolutely-positioned components */
  /* common... */
  .fc-bg,
  .fc-bgevent-skeleton,
  .fc-highlight-skeleton,
  .fc-helper-skeleton,
  .fc-bgevent-container,
  .fc-business-container,
  .fc-highlight-container,
  .fc-helper-container {
    display: none;
  }

  /* don't force a min-height on rows (for DayGrid) */
  .fc tbody .fc-row {
    height: auto !important;
    /* undo height that JS set in distributeHeight */
    min-height: 0 !important;
    /* undo the min-height from each view's specific stylesheet */
  }

  .fc tbody .fc-row .fc-content-skeleton {
    position: static;
    /* undo .fc-rigid */
    padding-bottom: 0 !important;
    /* use a more border-friendly method for this... */
  }

  .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {
    /* only works in newer browsers */
    padding-bottom: 1em;
    /* ...gives space within the skeleton. also ensures min height in a way */
  }

  .fc tbody .fc-row .fc-content-skeleton table {
    /* provides a min-height for the row, but only effective for IE, which exaggerates this value,
      making it look more like 3em. for other browers, it will already be this tall */
    height: 1em;
  }

  /* Undo month-view event limiting. Display all events and hide the "more" links
  --------------------------------------------------------------------------------------------------*/
  .fc-more-cell,
  .fc-more {
    display: none !important;
  }

  .fc tr.fc-limited {
    display: table-row !important;
  }

  .fc td.fc-limited {
    display: table-cell !important;
  }

  .fc-popover {
    display: none;
    /* never display the "more.." popover in print mode */
  }

  /* TimeGrid Restyling
  --------------------------------------------------------------------------------------------------*/
  /* undo the min-height 100% trick used to fill the container's height */
  .fc-time-grid {
    min-height: 0 !important;
  }

  /* don't display the side axis at all ("all-day" and time cells) */
  .fc-agenda-view .fc-axis {
    display: none;
  }

  /* don't display the horizontal lines */
  .fc-slats,
  .fc-time-grid hr {
    /* this hr is used when height is underused and needs to be filled */
    display: none !important;
    /* important overrides inline declaration */
  }

  /* let the container that holds the events be naturally positioned and create real height */
  .fc-time-grid .fc-content-skeleton {
    position: static;
  }

  /* in case there are no events, we still want some height */
  .fc-time-grid .fc-content-skeleton table {
    height: 4em;
  }

  /* kill the horizontal spacing made by the event container. event margins will be done below */
  .fc-time-grid .fc-event-container {
    margin: 0 !important;
  }

  /* TimeGrid *Event* Restyling
  --------------------------------------------------------------------------------------------------*/
  /* naturally position events, vertically stacking them */
  .fc-time-grid .fc-event {
    position: static !important;
    margin: 3px 2px !important;
  }

  /* for events that continue to a future day, give the bottom border back */
  .fc-time-grid .fc-event.fc-not-end {
    border-bottom-width: 1px !important;
  }

  /* indicate the event continues via "..." text */
  .fc-time-grid .fc-event.fc-not-end:after {
    content: "...";
  }

  /* for events that are continuations from previous days, give the top border back */
  .fc-time-grid .fc-event.fc-not-start {
    border-top-width: 1px !important;
  }

  /* indicate the event is a continuation via "..." text */
  .fc-time-grid .fc-event.fc-not-start:before {
    content: "...";
  }

  /* time */
  /* undo a previous declaration and let the time text span to a second line */
  .fc-time-grid .fc-event .fc-time {
    white-space: normal !important;
  }

  /* hide the the time that is normally displayed... */
  .fc-time-grid .fc-event .fc-time span {
    display: none;
  }

  /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */
  .fc-time-grid .fc-event .fc-time:after {
    content: attr(data-full);
  }

  /* Vertical Scroller & Containers
  --------------------------------------------------------------------------------------------------*/
  /* kill the scrollbars and allow natural height */
  .fc-scroller,
  .fc-day-grid-container,
  .fc-time-grid-container {
    /* */
    overflow: visible !important;
    height: auto !important;
  }

  /* kill the horizontal border/padding used to compensate for scrollbars */
  .fc-row {
    border: 0 !important;
    margin: 0 !important;
  }

  /* Button Controls
  --------------------------------------------------------------------------------------------------*/
  .fc-button-group,
  .fc button {
    display: none;
    /* don't display any button-related controls */
  }
}
</style>
